export default [
  {
    title: 'breadcrumb.senior',
    route: 'list-senior',
    icon: '',
    resource: 'senior',
    action: 'read',
  },
]
